import React, { Component } from 'react';

import './App.css';

class About extends Component {

  render() {
    return (
      <div className="about-container">
        <div className="page-heading"> Who Are We? </div>
        <div className="about-main">
          <div className="about-text"> Progressive Jamaica is a collective of progressively minded folks who are
            actively contributing to the enrichment of our fellow citizens. Our philosophy is one which considers
            inner as well as outer wealth, and as such our initiatives are focused on health of body and mind
            as well as business development and wealth building.
            Our ultimate aim is to contribute to the creation & nurture of a more egalitarian society, and we strive
            to reflect this in our guiding principles of:
          </div>
          <ul>
              <li>gender equity</li>
              <li>freedom of and from religion</li>
              <li>no political party affiliations</li>
              <li>environmental preservation</li>
          </ul>
          <div className="about-text">
          If you would like to learn more about the organization, please contact
          anya.marshall@progressivejamaica.com </div>
          </div>

        </div>
    );
  }
}

export default About;



/** WEBPACK FOOTER **
 ** ./src/About.js
 **/